const invoiceList = [
  {
    id: 28,
    createdBy: null,
    createdOn: "0001-01-01T00:00:00",
    modifiedBy: null,
    modifiedOn: null,
    gid: "cac2a079-2c37-4a68-ae22-d956e26a486d",
    ilgiliGid: "217AC10B-58CC-4372-A567-0E02B2C3D479",
    kod: "CONNECTOR",
    aciklama: "Connector üzerinden gelen TICARIFATURA",
    key:"197987979",
  },
  {
    id: 123123123,
    createdBy: null,
    createdOn: "0001-01-01T00:00:00",
    modifiedBy: null,
    modifiedOn: null,
    gid: "cac2a079-2c37-4a68-ae22-d956e26a486d",
    ilgiliGid: "217AC10B-58CC-4372-A567-0E02B2C3D479",
    kod: "CONNECTOR",
    aciklama: "Connector üzerinden gelen TICARIFATURA",
    key:"564544",
  },
  {
    invoiceId: "SFN2022000000001",
    receiverTaxId: "1234567890",
    invoiceDate: "01/01/2022",
    profileId: "TEMEL",
    invoiceTypeCode: "Satış",
    payableAmount:"5",
    documentCurrencyCode:"TRY",
    invoiceState: "İmza Bekliyor",
    uuid: "147AC10B-58CC-4372-A567-0E02B2C3D479",
    key:"1123123123123",
  },
  {
    invoiceId: "SFN2022000000002",
    receiverTaxId: "1234567890",
    invoiceDate: "01/01/2022",
    profileId: "TEMEL",
    invoiceTypeCode: "Satış",
    payableAmount:"5",
    documentCurrencyCode:"TRY",
    invoiceState: "İmza Bekliyor",
    key:"2",
    uuid: "147AC10B-58CC-4372-A567-0E02B2C3D479",
  },
  {
    invoiceId: "SFN2022000000003",
    receiverTaxId: "1234567890",
    invoiceDate: "01/01/2022",
    profileId: "TEMEL",
    invoiceTypeCode: "Satış",
    payableAmount:"5",
    documentCurrencyCode:"TRY",
    invoiceState: "İmza Bekliyor",
    key:"3",
    uuid: "1234567892",
  },
  {
    invoiceId: "SFN2022000000004",
    receiverTaxId: "1234567890",
    invoiceDate: "01/01/2022",
    profileId: "TEMEL",
    invoiceTypeCode: "Satış",
    payableAmount:"5",
    documentCurrencyCode:"TRY",
    invoiceState: "İmza Bekliyor",
    key:"4",
    uuid: "1234567893",
  },
];
export default invoiceList;
